import React from 'react';
import { useTranslation } from 'react-i18next';
import { CompanyPlanUpgradeFeatureEnum } from 'graphql-common';
import FeatureLockState from '@lib/components/FeatureLockState';
import Trans from '@lib/components/Trans/Trans';
import { PlanState } from '@lib/enums/plan';
import useOutletContext, { ContextProps } from 'hooks/useOutletContext';

export default function HistoryUpgradeRequiredState() {
  const { t } = useTranslation();
  const { handleOpenPlanModal }: ContextProps = useOutletContext();

  return (
    <FeatureLockState
      title={t('lock-state-title-document-history')}
      text={<Trans i18nKey="lock-state-text-document-history" />}
      onUpgrade={() =>
        handleOpenPlanModal(PlanState.Locked, [
          CompanyPlanUpgradeFeatureEnum.Documentation,
        ])
      }
    />
  );
}
